import React, { useEffect } from "react";

//translation
import { useTranslation } from "react-i18next";

interface Address {
  city?: string;
  state?: string;
  country?: string;
  lat?: number;
  lng?: number;
}

interface MapProps {
  address: Address;
}

const MapComponent: React.FC<MapProps> = ({ address }) => {
  const { t } = useTranslation();


  const { city = "", state = "", country = "", lat, lng } = address;

  if (!lat || !lng) {
    return <p>{t("Location data is not available.")}</p>;
  }

  return (
    <div className="listingSection__wrap">
      <div>
        <h2 className="text-2xl font-semibold">{t("Location")}</h2>
        <span className="block mt-2 text-neutral-500 dark:text-neutral-400">
          {city}, {state}, {country}
        </span>
      </div>
      <div className="w-14 border-b border-neutral-200 dark:border-neutral-700" />
      <div className="aspect-w-5 aspect-h-5 sm:aspect-h-3 ring-1 ring-black/10 rounded-xl z-0">
        <div className="rounded-xl overflow-hidden z-0">
          <iframe
            title="Location Map"
            width="100%"
            height="100%"
            loading="lazy"
            allowFullScreen
            referrerPolicy="no-referrer-when-downgrade"
            src={`https://www.google.com/maps/embed/v1/place?key=${process.env.REACT_APP_GOOGLE_MAP_API_KEY}&zoom=15&center=${lat},${lng}&q=${lat},${lng}`}
          ></iframe>
        </div>
      </div>
    </div>
  );
};

export default MapComponent;
